export default function isHTMLElement(element: Element | null): element is HTMLElement {
  return element?.tagName !== undefined;
}
